import { useMutation, useQueryClient } from '@tanstack/react-query';

const API_BASE = process.env.REACT_APP_API_BASE || '';

/**
 * Hook to accept a share link for a trip.
 * Adds the current user as a VIEWER collaborator on the trip (idempotent).
 * Used by SharedTripPage when the user clicks "View Trip".
 */
export function useAcceptShareLink() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ tripId, token }: { tripId: string; token: string }) => {
      const response = await fetch(
        `${API_BASE}/api/trips/${tripId}/accept-share-link?token=${encodeURIComponent(token)}`,
        { method: 'POST', credentials: 'include' }
      );
      if (!response.ok) {
        if (response.status === 404) {
          throw new Error('Share link expired or invalid');
        }
        throw new Error(`Failed to accept share link: ${response.status}`);
      }
      return response.json() as Promise<any>;
    },
    onSuccess: (_, { tripId }) => {
      queryClient.invalidateQueries({ queryKey: ['trip', tripId] });
      queryClient.invalidateQueries({ queryKey: ['collaborators', tripId] });
    },
  });
}
